import {LabelValueOption} from "Components/Common/SelectWrapper";

export const FAVORITE_DASHBOARDS = "FAVORITE DASHBOARDS";
export const ALL_DASHBOARDS = "all";

// TODO: Move this to a table in the db
export const SCHOOL_TYPE_OPTIONS: LabelValueOption[] =[
    "Athletic Training",
    "Biosciences",
    "Business",
    "Chiropractic",
    "Dental",
    "Education",
    "Internal",
    "Law",
    "Medicine",
    "Nursing",
    "Nutrition",
    "Occupational Therapy",
    "Optometry",
    "Osteopathic",
    "Pharmacy",
    "Physical Therapy",
    "Physician Assistant",
    "Podiatry",
    "Veterinary",
].map(str => ({value: str, label: str}));

export const SCHOOL_DATA_SOURCE_OPTIONS: LabelValueOption[] = [
    "AACP Curriculum Quality Surveys", "aacp_agency_only", "AAMC", "admissions", "AFPC", "ati",
    "AVMA Survey of Graduating Veterinary Students", "canvas", "core_elms", "cpje", "eoc", "eor", "examsoft",
    "examsoft2", "IPEDS", "ipeds", "lcme dci", "LCME Master", "mountain measurement", "MPJE", "NA-Embedded in workbook",
    "NAPLEX", "navle", "NCLEX", "PA Combined", "packrat", "pance", "PCOA", "PEBC", "rosh", "vea"].map(str => ({value: str, label: str}));


export const ACCEPTED_MIMETYPES = [
    {
        id: 1,
        extension: "pdf",
        mimetype: "application/pdf",
        icon: "pdf"
    },
    {
        id: 2,
        extension: "png",
        mimetype: "image/png",
        icon: "image"
    },
    {
        id: 3,
        extension: "jpeg",
        mimetype: "image/jpeg",
        icon: "image"
    },
    {
        id: 4,
        extension: "jpg",
        mimetype: "image/jpeg",
        icon: "image"
    },
    {
        id: 5,
        extension: "doc",
        mimetype: "application/msword",
        icon: "word"
    },
    {
        id: 6,
        extension: "docx",
        mimetype: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        icon: "word"
    },
    {
        id: 7,
        extension: "txt",
        mimetype: "txt/plain",
        icon: "word"
    },
    {
        id: 8,
        extension: "xls",
        mimetype: "application/vnd.ms-excel",
        icon: "excel"
    },
    {
        id: 9,
        extension: "xls",
        mimetype: "application/CDFV2",
        icon: "excel"
    },
    {
        id: 10,
        extension: "xlsx",
        mimetype: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        icon: "excel"
    },
    {
        id: 11,
        extension: "csv",
        mimetype: "text/csv",
        icon: "excel"
    },
    {
        id: 12,
        extension: "numbers",
        mimetype: "application/x-iwork-numbers-sffnumbers",
        icon: "excel"
    },
    {
        id: 13,
        extension: "pages",
        mimetype: "application/x-iwork-pages-sffpages",
        icon: "word"
    },
    {
        id: 14,
        extension: "ppt",
        mimetype: "application/vnd.ms-powerpoint",
        icon: "powerpoint"
    },
    {
        id: 15,
        extension: "pptx",
        mimetype: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        icon: "powerpoint"
    },
    {
        id: 16,
        extension: "key",
        mimetype: "application/x-iwork-keynote-sffkey",
        icon: "powerpoint"
    },
    {
        id: 17,
        extension: "zip",
        mimetype: "application/zip",
        icon: "file"
    },
    {
        id: 67,
        extension: "xls",
        mimetype: "text/html",
        icon: "excel"
    },
    {
        id: 68,
        extension: "xlsx",
        mimetype: "text/html",
        icon: "excel"
    }
];
